<template>
    <img src="/img/logo-thnic.svg" class="h-16 w-auto text-gray-700 sm:h-20">
</template>
